var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isKp && !_vm.drawerTag)?_c('KpUserWrap'):_c('ClientUserWrap',{attrs:{"site-ids":_vm.propsFilterSite}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }